import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapFilterFormComponent from './mapFilterForm.component';

let mapFilterFormModule = angular.module('mapFilterForm', [
  uiRouter
])

.component('mapFilterForm', mapFilterFormComponent)

.name;

export default mapFilterFormModule;
